import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

import * as apis from "../../../network/apis/companyPortalClients";
import { getCompanyClientsListMeta } from "../../../containers/Company-portal/Clients/clientMappers";
import { showErrorMsg, showSuccessMsg } from "../../../utils/Helpers";
import * as actions from "./actions";
import * as types from "./types";

const extractListItems = (response) => response?.data?.data ?? [];
const extractClient = (response) => response?.data?.data ?? null;

function* getCompanyClientsSaga({ payload }) {
  try {
    const response = yield call(apis.getCompanyClients, payload);
    yield put(
      actions.getCompanyClientsResponse({
        list: extractListItems(response),
        meta: getCompanyClientsListMeta(response),
      }),
    );
  } catch (error) {
    yield call(showErrorMsg, error.response?.data?.message);
    yield put(
      actions.getCompanyClientsResponse({
        list: [],
        meta: { currentPage: 1, count: 0, pages: 1 },
      }),
    );
  }
}

function* getCompanyClientSaga({ payload }) {
  const { id, onError } = payload || {};
  try {
    const response = yield call(apis.getCompanyClient, id);
    yield put(actions.getCompanyClientResponse(extractClient(response)));
  } catch (error) {
    yield put(actions.getCompanyClientResponse(null));
    const message = error?.response?.data?.message;
    if (message) yield call(showErrorMsg, message);
    if (typeof onError === "function") onError(error);
  }
}

function* updateCompanyClientSaga({ payload }) {
  const { id, data, successMessage, onSuccess, onError } = payload || {};
  try {
    const response = yield call(apis.updateCompanyClient, { id, data });
    const client = extractClient(response);
    yield put(actions.updateCompanyClientResponse(client));
    if (successMessage) yield call(showSuccessMsg, successMessage, true);
    if (typeof onSuccess === "function") onSuccess(response, client);
  } catch (error) {
    const message = error?.response?.data?.message;
    yield put(actions.updateCompanyClientResponse(null));
    if (message) yield call(showErrorMsg, message);
    if (typeof onError === "function") onError(error);
  }
}

function* createCompanyClientSaga({ payload }) {
  const { data, onSuccess, onError } = payload || {};
  try {
    const response = yield call(apis.createCompanyClient, data);
    yield put(
      actions.createCompanyClientSuccess(response?.data?.data ?? null),
    );
    const message = response?.data?.message;
    if (message) yield call(showSuccessMsg, message, true);
    if (typeof onSuccess === "function") onSuccess(response);
  } catch (error) {
    const message = error?.response?.data?.message;
    yield put(actions.createCompanyClientFailure({ error: message }));
    if (message) yield call(showErrorMsg, message);
    if (typeof onError === "function") onError(error);
  }
}

export default function* companyClientsSagas() {
  yield takeLatest(types.GET_COMPANY_CLIENTS_REQUEST, getCompanyClientsSaga);
  yield takeEvery(types.GET_COMPANY_CLIENT_REQUEST, getCompanyClientSaga);
  yield takeEvery(types.UPDATE_COMPANY_CLIENT_REQUEST, updateCompanyClientSaga);
  yield takeEvery(types.CREATE_COMPANY_CLIENT_REQUEST, createCompanyClientSaga);
}
